import * as React from "react";

// eslint-disable-next-line no-restricted-imports
import { AppButtonProps, useAppButton } from "@1js/acui-button/lib/Next";

import { RibbonButtonInternalProps } from "../RibbonButton.props";
import { renderRibbonControlLabel } from "./renderRibbonControlLabel";
import { RibbonButtonProps, RibbonButtonState } from "./RibbonButton.types";
import { useRibbonButtonVariant } from "./useRibbonButtonVariant";
/**
 * Given user props, returns state for a `RibbonButton`.
 */
export const useRibbonButton = (
  props: RibbonButtonInternalProps,
  ref: React.Ref<HTMLButtonElement>
): RibbonButtonState => {
  const { dataAutomationType, label, onRenderText, size, variant, variantId } =
    props;

  const appButtonState = useAppButton(
    {
      ...props,
      children: renderRibbonControlLabel(label, size, onRenderText),
      dataAutomationType: dataAutomationType ?? "RibbonButton",
      size: size?.toLowerCase() as RibbonButtonProps["size"],
    } as AppButtonProps,
    ref
  );

  useRibbonButtonVariant(
    appButtonState as RibbonButtonState,
    variant as RibbonButtonState["variant"],
    variantId as RibbonButtonState["variantId"]
  );

  return appButtonState;
};
